























































































import { Component, Vue } from 'vue-property-decorator';
import UserTransactions from '@/components/Users/Transactions.vue';
import usersApp from '@/store/types/usersApp';
import { Action, Getter } from 'vuex-class';
import {
  UserBalanceAccount,
  UsersAppParams
} from '@/store/interfaces/usersApp';
import unknowUser from '@/assets/images/unknow-user.png';
import emailVerification from '@/components/Reusable/badgeRedGreen.vue';
import { itemsRoute, navLink } from '@/ts/navegationLinks';
import { VuexFunction } from '@/ts/axios';

@Component({
  name: 'Profile',
  components: {
    UserTransactions,
    emailVerification,
  },
})
class Profile extends Vue {
  loading = true;
  items: itemsRoute[] = [
    {
      id: 1,
      icon: 'fas fa-clipboard-list',
      title: 'Transacciones',
      route: 'user-transactions',
      hash: 'transacciones',
      can: 'index_customers_payment_requests',
    },
    {
      id: 2,
      icon: 'fas fa-money-check',
      title: 'Retiros a cuentas bancarias',
      route: 'user-withdrawals',
      hash: 'retiros',
      can: 'index_customers_withdrawals',
    },
    {
      id: 3,
      icon: 'fas fa-hand-holding-usd',
      title: 'Transferencias',
      route: 'user-transfer',
      hash: 'transferencias',
      can: 'index_customers_withdrawals',
    },
    {
      id: 4,
      icon: 'fas fa-mobile-alt',
      title: 'Dispositivos',
      route: 'user-devices',
      hash: 'dispositivos',
      can: 'index_customers_devices',
    }
  ];

  navlink: navLink[] = [
    {
      name: 'Cuentas de usuario',
      active: false,
      to: '/accounts',
    },
    {
      name: 'Transacciones',
      active: true,
    }
  ];

  setProfileImage(url: string): string {
    return url || unknowUser;
  }

  get balance(): number {
    return (
      this.getBalanceAccountList
        .filter((balance) => balance.kind === 'cash')
        .map((balance) => balance.amount_cents)
        .reduce((accumulator, curr) => accumulator + curr, 0) / 100
    );
  }

  async created(): Promise<void> {
    await this.singleUser(`${this.$route.params.user_id}`);
    await this.userBalance(`${this.$route.params.user_id}`);
    this.$data.loading = false;
  }

  @Action(`usersApp/${usersApp.actions.SINGLE_USER}`) singleUser!: VuexFunction;
  @Action(`usersApp/${usersApp.actions.USER_BALANCE}`)
  userBalance!: VuexFunction;

  @Getter(`usersApp/${usersApp.getters.GET_SINGLE_USER}`)
  getSingleUser!: UsersAppParams;

  @Getter(`usersApp/${usersApp.getters.GET_USER_BALANCE}`)
  getBalanceAccountList!: UserBalanceAccount[];
}
export default Profile;
